import { exampleData } from "./feature-page";

export const maintenanceData = exampleData;
